export function formatSats(sats: number): string {
  return new Intl.NumberFormat("en-US").format(Math.round(sats));
}

export function healthLabel(health: number): { label: string; className: string } {
  if (health >= 75) return { label: "Good", className: "text-primary" };
  if (health >= 45) return { label: "Fair", className: "text-accent" };
  if (health > 0) return { label: "Poor", className: "text-destructive" };
  return { label: "Gone", className: "text-muted-foreground line-through" };
}
